import { formatPhone } from "@repo/utils"

// The API marks nearly every field optional and nullable (serialiser defaults),
// which would push null checks into every component. The mappers absorb that
// once, at the edge, with these helpers.

/**
 * Phone numbers are grouped here rather than at each render site: the API sends
 * them unspaced, every surface shows the same `+998 94 329 69 49` form, and
 * doing it once means a new page cannot forget. Strip the spaces back out if a
 * `tel:` link ever needs the raw value.
 */
export function phone(value: string | null | undefined): string {
  return formatPhone(value ?? "")
}

export function str(value: string | null | undefined): string {
  return value ?? ""
}

export function list<T>(value: T[] | null | undefined): T[] {
  return value ?? []
}

export function num(value: number | null | undefined): number {
  return value ?? 0
}

export function fullName(firstName: string, lastName: string, fallback: string): string {
  return [firstName, lastName].filter(Boolean).join(" ") || fallback
}
